import React from 'react'
import { observer, inject } from 'mobx-react'
import LoadingComponent from '../../../LoadingComponent'
import { Link } from 'react-router'
import Icon from '../../../util/Icon'
import DropdownMenu from '../../../navigation/DropdownMenu'
import { append } from '../../../../utils/url'
import { formatDate, formatSearchFilters } from '../../../../utils/format'
import OrderableTH from '../../../navigation/OrderableTH'
import StorePagination from '../../../navigation/StorePagination'

@inject('websites', 'searches', 'auth')
@observer
export default class SearchLibrary extends LoadingComponent {
  website = this.props.websites.current

  state = {
    search: '',
    order_by: 'created_at',
    order_dir: 'desc'
  }

  hasLoaded() {
    return this.props.searches.loaded
  }

  loadPage(nextPage) {
    const { page=1 } = this.props.location.query
    this.props.searches.loadPage(nextPage || page, this.state)
  }

  componentWillMount() {
    const { search='', order_by='created_at', order_dir='desc' } = this.props.location.query

    this.setState({ search, order_by, order_dir }, () => this.loadPage())
  }

  componentWillReceiveProps(nextProps) {
    const { page:next, ...nextQuery } = nextProps.location.query
    const { page:prev, ...prevQuery } = this.props.location.query

    if (next !== prev) {
      this.loadPage(next)
    } else if (nextQuery.order_by !== prevQuery.order_by || nextQuery.order_dir !== prevQuery.order_dir) {
      this.setState(nextQuery, () => this.loadPage())
    }
  }

  componentDidUpdate() {
    if (typeof(this.searchField) !== 'undefined') {
      this.searchField.focus()
    }
  }

  handleSearch = ({ target: { value:search } }) => {
    this.setState({ search }, () => this.loadPage())
  }

  deleteHandlerFor = search => event => {
    event.preventDefault()
    if (search.hotsheet_count || search.recommended_count) {
      alert("You cannot delete a search with active hotsheets or recommendations")
      return
    }
    const confirmed = window.confirm(`Really delete search: ${search.title}?`)
    if (!confirmed) {
      return
    }
    this.props.searches.delete(search.id)
  }

  renderLoaded() {
    const { search } = this.state
    const { user } = this.props.auth
    const { admin } = user

    return (
      <div className="container padded searches">
        <div className="panel full padded">
          <h2 className="title">Search Library</h2>
          <div className="table-actions">
            <input type="search" placeholder="Search Saved Searches..." title="Search by saved search name" value={search} onInput={this.handleSearch} ref={(el) => { this.searchField = el }} />
            <Link className="button" to={append('add')}>Create New Search</Link>
          </div>
          <div>
            <table className="zebra">
              <thead>
                <tr>
                  <OrderableTH query={this.state} field="title">Name</OrderableTH>
                  <th>Filters</th>
                  <th>Hotsheets</th>
                  <th>Recommended</th>
                  <th>Created By</th>
                  <OrderableTH query={this.state} field="created_at">Created</OrderableTH>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody className="padded">
                {this.props.searches.map(s => (
                  <tr key={s.id}>
                    <td>
                    { (admin || s.user_id === user.id) ? <Link to={append(`edit/${s.id}`)}>{s.title}</Link> : s.title }</td>
                    <td className="muted">{formatSearchFilters(s.params)}</td>
                    <td className="center">{s.hotsheet_count}</td>
                    <td className="center">{s.recommended_count}</td>
                    <td className="center">{s.user_name}</td>
                    <td className="center">{formatDate(s.created_at)}</td>
                    <td className="center">
                      <DropdownMenu menuClass="website-page-actions" menuTitle={<Icon icon="bars" />}>
                        <Link className="primary" to={`/website/${this.website.id}/hotsheets/add?search_id=${s.id}`}>New Hotsheet</Link>
                        <Link className="secondary" to={`/website/${this.website.id}/recommended/searches/add?search_id=${s.id}`}>Recommend</Link>
                        { (admin || s.user_id === user.id) ? <Link to={append(`edit/${s.id}`)}>Edit</Link> : null }
                        <Link to={append(`duplicate/${s.id}`)}>Duplicate</Link>
                        <a className="danger" to="#" onClick={this.deleteHandlerFor(s)}>Delete</a>
                      </DropdownMenu>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            <StorePagination store={this.props.searches} query={this.state} />
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// client/components/sections/website/SearchLibrary/index.js